import(/* webpackMode: "eager" */ "/codebuild/output/src2801287472/src/collinson-group-web/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/codebuild/output/src2801287472/src/collinson-group-web/src/contexts/SettingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2801287472/src/collinson-group-web/src/features/contentful/containers/ProductPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2801287472/src/collinson-group-web/src/features/contentful/contexts/RelatedInsightsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2801287472/src/collinson-group-web/src/layouts/OpenAccessLayout.tsx");
